import { render, staticRenderFns } from "./ActiveTab.vue?vue&type=template&id=cdbb6884"
import script from "./ActiveTab.vue?vue&type=script&lang=js"
export * from "./ActiveTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports